export interface ReportMetrics {
  activeEmployees: number;
  monthlyVolume: number;
  activeAdvances: number;
  successRate: number;
}

export interface GeneratedReport {
  id: string;
  title: string;
  employees: string;
  period: string;
  format: 'PDF' | 'Excel';
  size: string;
  status: 'Listo' | 'Procesando';
}

export interface ReportTemplate {
  id: string;
  name: string;
  description: string;
}

export interface EmployeeMovement {
  id: string;
  date: string;
  time: string;
  employee: string;
  employeeId: string;
  department: string;
  type: 'nomina' | 'adelanto' | 'reembolso' | 'bonus' | 'carga-tarjeta';
  amount: number;
  status: 'Exitoso';
  reference: string;
}

export interface Receipt {
  id: string;
  reference: string;
  employee: string;
  type: 'nomina' | 'adelanto' | 'reembolso' | 'bonus' | 'carga-tarjeta';
  tags: string[];
}

export interface ScheduledReport {
  id: string;
  name: string;
  frequency: 'Semanal' | 'Mensual';
  format: 'Excel' | 'PDF';
  nextSend: string;
  recipients: number;
  status: 'Activo';
}

export interface MonthlyMetric {
  label: string;
  value: number | string;
  trend?: string;
}

export interface DepartmentActivity {
  name: string;
  operations: number;
  volume: number;
}

export const reportMetrics: ReportMetrics = {
  activeEmployees: 247,
  monthlyVolume: 2100000,
  activeAdvances: 32,
  successRate: 98.2,
};

export const generatedReports: GeneratedReport[] = [
  {
    id: '1',
    title: 'Resumen de Nómina',
    employees: 'Todos los empleados',
    period: 'Enero 2024',
    format: 'PDF',
    size: '2.3 MB',
    status: 'Listo',
  },
  {
    id: '2',
    title: 'Adelantos por Departamento',
    employees: 'Ventas, Marketing',
    period: 'Diciembre 2023',
    format: 'Excel',
    size: '845 KB',
    status: 'Listo',
  },
  {
    id: '3',
    title: 'Estado de Cuenta Individual',
    employees: 'Ana García Mendoza',
    period: 'Q4 2023',
    format: 'PDF',
    size: '',
    status: 'Procesando',
  },
];

export const reportTemplates: ReportTemplate[] = [
  {
    id: '1',
    name: 'Resumen de Nómina',
    description: 'Dispersiones de nómina por período y departamento',
  },
  {
    id: '2',
    name: 'Adelantos de Empleados',
    description: 'Adelantos otorgados, activos y pagados',
  },
  {
    id: '3',
    name: 'Operaciones por Departamento',
    description: 'Análisis de gastos y movimientos por área',
  },
  {
    id: '4',
    name: 'Cumplimiento Interno',
    description: 'Métricas de compliance y auditoría',
  },
];

export const employeeMovements: EmployeeMovement[] = [
  {
    id: '1',
    date: '2024-01-18',
    time: '14:30',
    employee: 'Ana García Mendoza',
    employeeId: 'EMP-001',
    department: 'Ingeniería',
    type: 'nomina',
    amount: 25000.0,
    status: 'Exitoso',
    reference: 'NOM240118001',
  },
  {
    id: '2',
    date: '2024-01-17',
    time: '09:15',
    employee: 'Carlos Mendoza López',
    employeeId: 'EMP-002',
    department: 'Ventas',
    type: 'adelanto',
    amount: 8500.0,
    status: 'Exitoso',
    reference: 'ADL240117002',
  },
  {
    id: '3',
    date: '2024-01-16',
    time: '16:45',
    employee: 'María Elena Rodríguez',
    employeeId: 'EMP-003',
    department: 'Marketing',
    type: 'reembolso',
    amount: 1250.0,
    status: 'Exitoso',
    reference: 'RBL240116003',
  },
  {
    id: '4',
    date: '2024-01-15',
    time: '11:20',
    employee: 'Roberto Vásquez Herrera',
    employeeId: 'EMP-004',
    department: 'Finanzas',
    type: 'bonus',
    amount: 5000.0,
    status: 'Exitoso',
    reference: 'BON240115004',
  },
  {
    id: '5',
    date: '2024-01-14',
    time: '13:30',
    employee: 'Patricia Gómez Torres',
    employeeId: 'EMP-005',
    department: 'Recursos Humanos',
    type: 'carga-tarjeta',
    amount: 3000.0,
    status: 'Exitoso',
    reference: 'CRG240114005',
  },
];

export const receipts: Receipt[] = [
  {
    id: '1',
    reference: 'NOM240118001',
    employee: 'Ana García Mendoza',
    type: 'nomina',
    tags: ['nomina', 'CEP'],
  },
  {
    id: '2',
    reference: 'ADL240117002',
    employee: 'Carlos Mendoza López',
    type: 'adelanto',
    tags: ['adelanto', 'CEP'],
  },
  {
    id: '3',
    reference: 'RBL240116003',
    employee: 'María Elena Rodríguez',
    type: 'reembolso',
    tags: ['reembolso', 'CEP'],
  },
  {
    id: '4',
    reference: 'BON240115004',
    employee: 'Roberto Vásquez Herrera',
    type: 'bonus',
    tags: ['bonus', 'CEP'],
  },
  {
    id: '5',
    reference: 'CRG240114005',
    employee: 'Patricia Gómez Torres',
    type: 'carga-tarjeta',
    tags: ['carga-tarjeta', 'CEP'],
  },
];

export const scheduledReports: ScheduledReport[] = [
  {
    id: '1',
    name: 'Resumen Semanal de Operaciones',
    frequency: 'Semanal',
    format: 'Excel',
    nextSend: '2024-01-22 09:00',
    recipients: 2,
    status: 'Activo',
  },
  {
    id: '2',
    name: 'Reporte Mensual de Adelantos',
    frequency: 'Mensual',
    format: 'PDF',
    nextSend: '2024-02-01 08:00',
    recipients: 1,
    status: 'Activo',
  },
];

export const monthlyMetrics: MonthlyMetric[] = [
  {
    label: 'Total Empleados Activos',
    value: 247,
    trend: 'Empleados con operaciones en el mes',
  },
  {
    label: 'Adelantos Otorgados',
    value: 32,
    trend: 'Adelantos aprobados este mes',
  },
  {
    label: 'Volumen de Nómina',
    value: '$2,145,890',
    trend: 'Total dispersado en nómina',
  },
  {
    label: 'Tasa de Cumplimiento',
    value: '98.2%',
    trend: 'Operaciones exitosas vs totales',
  },
];

export const departmentActivity: DepartmentActivity[] = [
  {
    name: 'Ingeniería',
    operations: 45,
    volume: 456780,
  },
  {
    name: 'Ventas',
    operations: 32,
    volume: 234590,
  },
  {
    name: 'Marketing',
    operations: 28,
    volume: 189340,
  },
  {
    name: 'Finanzas',
    operations: 19,
    volume: 145200,
  },
];
